/**
 * Cleans product titles for display.
 *
 * Junk patterns from scrapers (SerpApi, vision-detected) often include:
 * - Comma-separated SEO keyword runs: "X Dress, Women, Cotton, M, Blue"
 * - Long descriptive padding: "X Dress Long Sleeve Puff Vintage..."
 *
 * Strategy:
 * 1. Trim whitespace
 * 2. Take content before first comma (drops SEO keyword runs)
 * 3. If still too long, truncate at maxLen with ellipsis
 * 4. Return null for empty/nullish input (caller omits render)
 */
export function cleanProductTitle(
  raw: string | null | undefined,
  maxLen = 48,
): string | null {
  if (!raw) return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;

  const beforeComma = trimmed.split(",")[0].trim();
  if (!beforeComma) return null;

  if (beforeComma.length <= maxLen) return beforeComma;
  return beforeComma.slice(0, maxLen - 1).trimEnd() + "…";
}
